import { Avatar, Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DataGrideView from "../../../../Component/DataGrideView/DataGrideView";
import { API_URL } from "../../../../Apis/config";
import SplitButton from "../../../../Component/Button/SplitButton";
import ConfirmationDailog from "../../../../Component/Dailog/ConfirmationDailog";
import {
  DELETE_WEB_FEATURE,
  GET_WEB_FEATURE,
} from "../../../../Apis/web/feature_api";
import AddUpdateWebFeatureDailog from "../../../../Component/Dailog/web/AddUpdateFeature";

function WebFeature() {
  const [open, setOpen] = useState(false);
  const [row, setRow] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isLoading, SetIsLoading] = useState(true);

  const getData = async () => {
    SetIsLoading(true);
    const res = await GET_WEB_FEATURE();

    if (res && res?.s) {
      setRow(res?.r ?? []);
    } else {
      setRow([]);
    }
    SetIsLoading(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (v) => {
    if (v) {
      getData();
    }
    setSelectedRow(null);
    setOpen(false);
  };

  const handleCloseDelete = async (v) => {
    if (v) {
      await DELETE_WEB_FEATURE(selectedRow.id);
      getData();
    }
    setSelectedRow(null);
    setDeleteOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "SR.",
      filterable: false,
      headerAlign: "center",
      align: "center",
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        // console.log(params);
        return params.api.getRowIndex(params.row.id) + 1;
      },
    },
    {
      field: "name",
      headerName: "Name",
      filterable: false,
      minWidth: 210,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        // console.log(params);
        return (
          <Typography sx={{ py: 1, fontSize: "13px" }}>
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      filterable: false,
      minWidth: 210,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        // console.log(params);
        return (
          <Typography sx={{ py: 1, fontSize: "13px" }}>
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "url",
      headerName: "Url",
      filterable: false,
      minWidth: 210,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        // console.log(params);
        return (
          <Typography sx={{ py: 1, fontSize: "13px" }}>
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "logo",
      headerName: "Logo",
      filterable: false,
      minWidth: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value ? (
          <Avatar
            onClick={() =>
              window.open(
                API_URL.baseUrl + API_URL.webFeatureLogo + params.value,
                "_blank"
              )
            }
            sx={{ height: "30px", width: "30px", cursor: "pointer" }}
            src={API_URL.baseUrl + API_URL.webFeatureLogo + params.value}
          />
        ) : (
          "-"
        );
      },
    },
    {
      field: "created_at",
      headerName: "Label",
      filterable: false,
      minWidth: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return <Typography
        sx={{
          backgroundColor:"#f0f0f0",
          padding:"0px 10px",
          borderRadius:"10px"
        }}
        >{diif_number_days(params.value) > 30 ? "Old" : "New"}</Typography>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 70,
      type: "number",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <SplitButton
          key={params.id}
          title={params.value}
          // isView={rightsUser.includes(4) ? 1 : null}
          dataId={params.row.id}
          isDelete={1}
          isEdit={1}
          onEdit={onEdit}
          onView={null}
          onDelete={onDelete}
          // deleteText="Delete"
        />
      ),
    },
  ];

  const diif_number_days = (d) => {
    let date1 = new Date();
    let date2 = new Date(d);

    // Calculating the time difference
    // of two dates
    let Difference_In_Time = date1.getTime() - date2.getTime();

    // Calculating the no. of days between
    // two dates
    let Difference_In_Days = Math.round(
      Difference_In_Time / (1000 * 3600 * 24)
    );
    return Difference_In_Days;
  };

  const onEdit = (id) => {
    // console.log(id, "id");
    setSelectedRow(() => row.find((v) => v.id == id));
    setOpen(true);
  };

  const onDelete = (id) => {
    setSelectedRow(() => row.find((v) => v.id == id));
    setDeleteOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          flexDirection: "column",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            width: "135px",
            mb: 1,
          }}
          onClick={handleOpen}
        >
          <Typography sx={{ color: "primary.main" }}>Add Feature</Typography>
        </Button>

        <Box sx={{ boxShadow: "3px 3px 7px 0px #00000040", width: "100%" }}>
          <DataGrideView
            rows={row}
            columns={columns}
            // callBack={callBack}
            isLoading={isLoading}
            sx={{
              height: "75vh",
            }}
            autoHeight={true}
          />
        </Box>
      </Box>
      {open && (
        <AddUpdateWebFeatureDailog
          open={open}
          handleOnClose={handleClose}
          row={selectedRow}
        />
      )}

      {deleteOpen && (
        <ConfirmationDailog
          handleOnClose={handleCloseDelete}
          open={deleteOpen}
          content="Are you sure, You want to delete this feature?"
          title="Delete Feature!"
        />
      )}
    </>
  );
}

export default WebFeature;
